export const updateObject = (oldObject, updateValue) => {
  return { ...oldObject, ...updateValue };
};

export const kFormatter = (num, f = "k") => {
  return Math.abs(num) > 999
    ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + f
    : Math.sign(num) * Math.abs(num);
};

export const formatNumber = (number) => {
  return new Intl.NumberFormat(["ban", "id"]).format(number);
};
